import utils from 'utils'
class loglistCtrl {
    constructor($scope, httpRequest, $uibModal) {
        httpRequest.get_dictByTypeArr(['operate_type', 'operate_result']).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })
        // 下拉组件配置
        $scope.queryConfig = {
            queryName: 'orgName',
            queryKey: 'orgId',
            queryType: 'tree',
            parentIdName: 'parentOrgId',
            multiple: false,
            parentId: -1,
            defaultSelect: [],
        }
        $scope.queryFunctionConfig = {
            queryName: 'functionName',
            queryKey: 'functionId',
            queryType: 'tree',
            parentIdName: 'parentFunctionId',
            multiple: false,
            parentId: -1,
            defaultSelect: [],
        }
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                endTime: initDate(),
                operateFunctionList: [],
                operateType: null,
                resultRemark: '',
                orgIdLsit: [],
                startTime: initDate(),
                userName: null,
            },
        }
        $scope.reset = function () {
            $scope.queryParam.param = {
                endTime: initDate(),
                operateFunctionList: [],
                operateType: null,
                resultRemark: '',
                orgIdLsit: [],
                startTime: initDate(),
                userName: null,
            }
            $scope.queryConfig.defaultSelect = []
            $scope.queryFunctionConfig.defaultSelect = []
        }
        // $scope.reset()
        $scope.orgList = [] // 机构
        $scope.functionList = [] // 模块
        $scope.typeList = [] // 操作类型
        $scope.operateFunctionList = [] // 操作模块
        $scope.orgNameMap = {}
        $scope.functionNameMap = {}
        $scope.user = JSON.parse(localStorage.user_info).user
        // FIX:by wxb for 机构下来修改
        $scope.userAllOrgList = JSON.parse(localStorage.user_info).orgList
        for (const i in $scope.userAllOrgList) {
            $scope.orgNameMap[$scope.userAllOrgList[i].orgId] = $scope.userAllOrgList[i].orgName
        }

        // 机构变化
        $scope.orgSelectChange = function (v) {
            const orgSelectArr = v
            const orgSelectL = orgSelectArr.length
            if (orgSelectL > 0) {
                for (const i in orgSelectArr) {
                    $scope.queryParam.param.orgIdLsit[i] = orgSelectArr[i].orgId
                }
            } else {
                $scope.queryParam.param.orgIdLsit = []
            }
        }

        // 操作模块
        httpRequest.get_getSysFunctionListt().then((res) => {
            const list = res.data.value
            const tempList = []
            for (let i = 0; i < list.length; i++) {
                if (list[i].functionType == '3') {} else {
                    tempList.push(list[i])
                }
            }
            $scope.operateFunctionList = tempList
        })

        // 操作模块数据字段
        httpRequest.get_getFunctionUrlMap().then((res) => {
            $scope.functionNameMap = res.data.value
        })


        // 机构变化
        $scope.functionSelectChange = function (v) {
            const orgSelectArr = v
            const orgSelectL = orgSelectArr.length
            if (orgSelectL > 0) {
                for (const i in orgSelectArr) {
                    $scope.queryParam.param.operateFunctionList[i] = orgSelectArr[i].url
                }
            } else {
                $scope.queryParam.param.operateFunctionList = []
            }
        }

        function queryLogInfo() {
            httpRequest.post_getPageOperateLogList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total
                $scope.currentPage = ++res.data.value.prePage
                $scope.maxSize = res.data.value.pageSize
            })
        }

        $scope.currentPage = 1 // 设置显示第一页
        $scope.maxSize = 10 // 每一叶显示记录数


        $scope.pageChanged = function () { // 点击页码发起查询
            queryLogInfo()
        }


        $scope.init = function () {
            $scope.search = {}
            $scope.search.isRoleOwner = 1
            $scope.currentPage = 1 // 设置显示第一页
            $scope.maxSize = 10 // 每一叶显示记录数
            queryLogInfo()
        }
        $scope.init()

        $scope.datePickerConfig = {
            format: 'yyyy-mm-dd',
            minView: 1,
            startView: 2,
        }


        // 时间格式初始化
        function initDate(month, year, day) {
            const date = new Date()
            const y = year || date.getFullYear()
            let m = month || date.getMonth() + 1
            let d = day || date.getDate()
            m = m < 10 ? `0${m}` : m,
                d = d < 10 ? `0${d}` : d
            return `${y}-${m}-${d}`
        }
        // 搜索
        $scope.searchlist = function () { // 点击搜索发起查询
            queryLogInfo()
        }
        $scope.searchKeyUpEnter = function (e) {
            const keycode = window.event ? e.keyCode : e.which // 获取按键编码
            if (keycode == 13) {
                queryLogInfo()
            }
        }
        $scope.getLog = function () {
            $uibModal.open({
                templateUrl: 'getLog.html',
                openedClass: 'mod-modal mod-modal-xs',
                animation: true,
                controller: ['$scope', '$uibModalInstance', 'logger', 'httpRequest', '$filter', function ($scope, $uibModalInstance, logger, httpRequest, $filter) {
                    $scope.param = {
                        startTime: $filter('date')(new Date(), 'yyyy-MM-dd'),
                        endTime: $filter('date')(new Date(), 'yyyy-MM-dd')
                    }
                    $scope.cancel = function cancel() {
                        $uibModalInstance.close()
                    }
                    $scope.logType1 = '1'
                    $scope.logType2 = '0'
                    $scope.ok = function ok() {
                        if ($scope.logType2 == 0 && $scope.logType1 == 0) return logger.logError('请选择需要下载的日志类型')
                        let logType = 0
                        if ($scope.logType1 == 1 && $scope.logType2 == 1) {
                            logType = 2
                        } else if ($scope.logType2 == 1) {
                            logType = 4
                        }

                        utils.loading('正在获取本地日志')
                        let realUrl = REAL_URL.replace('8888', localStorage.soapPort)
                        if (logType == 4) realUrl = location.protocol + '//soap.szhtxx.com:8889/InvDk'
                        httpRequest.post_base64DeCode({
                            invData: JSON.stringify({
                                "beginTime": $scope.param.startTime + ' 00:00:01',
                                "endTime": $scope.param.endTime + ' 23:59:59',
                                logType
                            }),
                            codeType: 'encode'
                        }).then(res => {
                            $.post({
                                url: realUrl,
                                data: {
                                    SID: '60',
                                    SIDParam: res.data.value,
                                },
                                timeout: 30000,
                            }).then((data) => {
                                if (logType == 4) {
                                    data = JSON.parse(data)
                                    if (data.retcode == 1) {
                                        const arr = data.zipFilePath.split('\\')
                                        const fileName = arr[arr.length - 1]
                                        logger.logSuccess(`已成功打包需要的日志文件${fileName}在您的桌面`)
                                        $uibModalInstance.close()
                                    } else {
                                        logger.logError(data.retmsg)
                                    }
                                    utils.loaded()
                                } else {
                                    const DECMSG = JSON.parse(data).ENCMSG.replace(new RegExp('[_]', 'gm'), '+')
                                        .replace(new RegExp(/(\r)/g), '')
                                        .replace(new RegExp(/(\n)/g), '')
                                    httpRequest.post_base64DeCode({
                                        invData: DECMSG,
                                        codeType: 'decode',
                                    }).then((res) => {
                                        $.post({
                                            url: `${window.location.origin}/etcloud/etcloud-sys/common/common/getJSONObject`,
                                            dataType: 'json',
                                            data: JSON.stringify({
                                                data: res.data.value
                                            }),
                                            contentType: 'application/json; charset=utf-8',
                                            success(res) {
                                                const jsonObj = res.value
                                                if (jsonObj.retcode == 1) {
                                                    const arr = jsonObj.zipFilePath.split('\\')
                                                    const fileName = arr[arr.length - 1]
                                                    logger.logSuccess(`已成功打包需要的日志文件${fileName}在您的桌面`)
                                                    $uibModalInstance.close()
                                                } else {
                                                    logger.logError(jsonObj.retmsg)
                                                }
                                                utils.loaded()
                                            }
                                        })
                                    })
                                }
                            }, () => {
                                logger.logError('获取日志失败，请检查相关接口程序是否正常启动')
                                utils.loaded()
                            })
                        })
                    }
                }],
            })
        }
    }
}
loglistCtrl.$inject = ['$scope', 'httpRequest', '$uibModal']
export default loglistCtrl


// WEBPACK FOOTER //
// ./src/app/system/log/operation/loglistCtrl.js